import { render } from "./BuzzEmployeeName.vue?vue&type=template&id=6b562642&scoped=true"
import script from "./BuzzEmployeeName.vue?vue&type=script&lang=js"
export * from "./BuzzEmployeeName.vue?vue&type=script&lang=js"

import "./buzz-employee-link.scss?vue&type=style&index=0&id=6b562642&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b562642"]])

export default __exports__